/**
 * Copy-to-clipboard for promo-countdown-bar sections.
 * Scoped per section root via [data-promo-countdown-bar].
 */
(function () {
  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (err) {
        reject(err);
      } finally {
        document.body.removeChild(ta);
      }
    });
  }

  function initBar(root) {
    if (root.dataset.copyInit === 'true') return;
    root.dataset.copyInit = 'true';

    var btn = root.querySelector('[data-copy-code]');
    if (!btn) return;

    var code = btn.getAttribute('data-code') || '';
    var defaultLabel = btn.getAttribute('data-label-default') || 'Copy Code';
    var copiedLabel = btn.getAttribute('data-label-copied') || 'Copied!';
    var labelEl = btn.querySelector('[data-copy-label]');
    var statusEl = root.querySelector('[data-copy-status]');
    var resetTimer;

    function setCopiedState() {
      btn.classList.add('is-copied');
      if (labelEl) labelEl.textContent = copiedLabel.toUpperCase();
      if (statusEl) statusEl.textContent = copiedLabel;
      clearTimeout(resetTimer);
      resetTimer = setTimeout(function () {
        btn.classList.remove('is-copied');
        if (labelEl) labelEl.textContent = defaultLabel.toUpperCase();
        if (statusEl) statusEl.textContent = '';
      }, 2000);
    }

    btn.addEventListener('click', function () {
      copyText(code).then(setCopiedState).catch(function () {
        if (statusEl) statusEl.textContent = 'Press and hold to copy';
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-promo-countdown-bar]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-promo-countdown-bar]');
    if (root) initBar(root);
  });
})();
